/**
 * Whether a CMS seasonal banner should show (enabled + optional date window).
 */
export function isSeasonalNoticeActive(notice, now = new Date()) {
  if (!notice?.enabled || !notice.message) return false;

  const today = now.toISOString().split('T')[0];
  if (notice.startDate && today < notice.startDate) return false;
  if (notice.endDate && today > notice.endDate) return false;
  return true;
}
